import script from "./SyncOperationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncOperationPage.vue?vue&type=script&setup=true&lang=ts"

import "./SyncOperationPage.vue?vue&type=style&index=0&id=6c8fe1f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c8fe1f0"]])

export default __exports__